<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-notice' class='navbarbtn' v-if='showSubPOInStockNoticePower'
        @click='showSubInStockNoticeDialogMD'>
        收料通知/请检
      </el-button>

      <el-button type='danger' icon='sys sys-notice' class='navbarbtn' v-if='showSubPOOutStockNoticePower'
        @click='showSubOutStockNoticeDialogMD'>
        退料通知
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.sourceBillNo' style='width: 125px;' placeholder='源单单号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='130px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :expandRowKeys='mainTable.expandRowKeys'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <div v-if='scope.data.row.TranType === "72"'>
          <el-tooltip effect='dark' content='重新上传至金蝶' placement='top-start' v-if='showReUploadSubPOInStockNoticePower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadSubPOInStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedSubPOInStockNoticePower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedSubPOInStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showSubPOInStockEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
        <div v-if='scope.data.row.TranType === "73"'>
          <el-tooltip effect='dark' content='重新上传至金蝶' placement='top-start' v-if='showReUploadSubPOOutStockNoticePower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadSubPOOutStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedSubPOOutStockNoticePower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedSubPOOutStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showSubPOInStockEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>源单单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>检验方式</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>仓库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>仓位代码</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>生成/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppie in scope.data.row.detailDt1'
            :key='ppie.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppie.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppie.MESSourceBillNo}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppie.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppie.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppie.Qty}}{{ppie.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppie.StockQty}}{{ppie.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppie.ReturnQty}}{{ppie.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{showPOInStockEntryTransformSpecialString('CheckMethod', ppie.CheckMethod)}} </span></div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'><span style='color: blue;'>{{ppie.DCStockName}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'><span style='color: blue;'>{{ppie.DCSPNumber}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{ppie.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span style='color: blue;'>
                {{!ppie.KFDate ? '' : dateTimeUtil.formartDateTime(new Date(ppie.KFDate), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{ppie.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: blue;'>{{ppie.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog title='收料通知/请检' :visible.sync='showSubInStockNoticeDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='mesSourceTranType' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='mesSourceTranType in mainTable.mesSourceTypes'
            :key='mesSourceTranType.code' :label='mesSourceTranType.name' :value='mesSourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableSelect v-model='mesSourceInterID'
          class='inputField-input' ref='mesSourceInterIDTableSelect'
          :displayValue='""' :disabled='scanQRCodes.length > 0'
          returnCode='InterID' displayCode='BillNo'
          customFilterStr=" AND Status IN ('1','2')"
          style='width: 200px;' tableCode='PM_SubContract'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          检验方式
        </div>
        <el-select v-model='subPOInStockInfo.CheckMethod' placeholder='请选择'
          class='inputField-input' @change='checkMethodChange' :clearable='false'
          style='width: 200px;' size='mini'>
          <el-option v-for='checkMethod in checkMethods'
            :key='checkMethod.code' :label='checkMethod.name' :value='checkMethod.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          收料仓库
        </div>
        <el-select v-model='subPOInStockInfo.DCStockID' placeholder='请选择'
          class='inputField-input' @change='dcstockChange'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          收料仓位
        </div>
        <TableSelect v-model='subPOInStockInfo.DCSPID' ref='subPOInStockInfoDCSPIDTableSelect'
          class='inputField-input'
          :displayValue='""' :customFilterStr="' AND SPGroupID=\'' + dcstockTeam + '\''"
          returnCode='SPID' displayCode='Name'
          style='width: 200px;' tableCode='BD_StockPlace'></TableSelect>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='subPOInStockInfo.Explanation' size='mini' style='width: 760px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='scanQRCodesTable' style='margin-top: 120px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='Status' label='状态' width='60'>
          <template #default='scope'>
            {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
          </template>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='subInStockNotice()' size='mini'>收料通知/请检</el-button>
        <el-button @click='showSubInStockNoticeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='退料通知' :visible.sync='showSubOutStockNoticeDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='outSourceTranType' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='outSourceTranType in mainTable.outSourceTypes'
            :key='outSourceTranType.code' :label='outSourceTranType.name' :value='outSourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='outScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='subPOOutStockInfo.Explanation' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备  注
        </div>
        <el-input v-model='subPOOutStockInfo.Remark' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='scanQRCodesTable' style='margin-top: 120px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='SubContractBillNo' label='委外单号' width='200'>
        </el-table-column>
        <el-table-column prop='POInStockBillNo' label='收料通知单号' width='200'>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='Status' label='状态' width='60'>
          <template #default='scope'>
            {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
          </template>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='outDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='subOutStockNotice()' size='mini'>退料通知</el-button>
        <el-button @click='showSubOutStockNoticeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='收料通知/请检单明细' :visible.sync='showSubPOInStockEntryDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='subPOInStockEntry' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt1'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.SupplyBatchNo}} </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格型号' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='80'>
        </el-table-column>
        <el-table-column prop='DCStockName' label='仓库' width='160'>
        </el-table-column>
        <el-table-column prop='DCSPNumber' label='仓位' width='120'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import TableSelect from '@/components/custom/TableSelect.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'SubPOInStock',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_SubPOInstock',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',
        sourceBillNo: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: [],

        mesSourceTypes: [],
        outSourceTypes: []
      },

      dateTimeUtil: dateTimeUtil,

      showSubInStockNoticeDialog: false,
      mesSourceTranType: '1007105',
      mesSourceInterID: '',
      qrcodeStatuss: [],
      subPOInStockInfo: {
        Explanation: '',
        DCStockID: '',
        DCSPID: '',
        CheckMethod: '351'
      },
      checkMethods: [],
      stocks: [],
      allStocks: [],
      dcstockTeam: '',
      scanQRCode: '',
      scanQRCodes: [],

      showSubPOInStockEntryDialog: false,
      subPOInStockEntry: [],
      subPOInStock: {},

      showSubOutStockNoticeDialog: false,
      outSourceTranType: '72',
      outSourceInterID: '',
      subPOOutStockInfo: {
        Explanation: '',
        Remark: ''
      },

      showSubPOInStockNoticePower: false,
      showReUploadSubPOInStockNoticePower: false,
      showDeletedSubPOInStockNoticePower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.mainTable.mesSourceTypes = code.getCode(codes, 'WMS_TranType')
    that.mainTable.outSourceTypes = code.getCode(codes, 'WMS_TranType')
    that.qrcodeStatuss = code.getCode(codes, 'WMS_QRCode_Status')
    that.checkMethods = code.getCode(codes, 'WMS_CheckMethod')
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const stockObj = await stockObjPromise
    that.allStocks = stockObj.tableContent
    that.checkMethodChange()
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.sourceBillNo) {
        const sourceBillNos = that.mainTable.sourceBillNo.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < sourceBillNos.length; i++) {
          detail1FilterStr += " OR SourceBillNo LIKE'%" + sourceBillNos[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.TranType === '73') {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': '#FF6347', color: 'red' }
        } else if (data.row.Closed === '1' || data.row.Status === '3') {
          return { 'background-color': '#CCCCCC', color: 'red' }
        } else {
          return { color: 'red' }
        }
      } else {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': '#FF6347' }
        } else if (data.row.Closed === '1' || data.row.Status === '3') {
          return { 'background-color': '#CCCCCC' }
        } else {
          return {}
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 收料通知单生成弹出框
    showSubInStockNoticeDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      if (that.$refs.mesSourceInterIDTableSelect) {
        that.$refs.mesSourceInterIDTableSelect.clearSelected()
      }
      that.showSubInStockNoticeDialog = true
    },

    // 获取收料通知扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 250 + 'px'
    },

    // 显示条码明细表格特征字符串转换方法
    showQRCodesTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'Status') {
        return table.specialStringDisplayTransform(val, that.qrcodeStatuss)
      }
    },

    // 检验方式选择方法
    checkMethodChange: function () {
      const that = this
      that.stocks = []
      if (that.subPOInStockInfo.CheckMethod === '352') {
        for (let i = 0; i < that.allStocks.length; i++) {
          if (that.allStocks[i].IncludeAccounting === 'True') {
            that.stocks.push(that.allStocks[i])
          }
        }
      } else {
        for (let i = 0; i < that.allStocks.length; i++) {
          if (that.allStocks[i].TypeId === '501') {
            that.stocks.push(that.allStocks[i])
          }
        }
      }
      that.subPOInStockInfo.DCStockID = ''
      if (that.$refs.subPOInStockInfo) {
        that.$refs.subPOInStockInfoDCSPIDTableSelect.clearSelected()
      }
    },

    // 发料仓库选择方法
    dcstockChange: function () {
      const that = this
      if (that.$refs.subPOInStockInfoDCSPIDTableSelect) {
        that.$refs.subPOInStockInfoDCSPIDTableSelect.clearSelected()
      }
      for (let i = 0; i < that.stocks.length; i++) {
        if (that.stocks[i].StockID === that.subPOInStockInfo.DCStockID) {
          that.dcstockTeam = that.stocks[i].SPGroupID
          break
        }
      }
    },

    // 扫码方法
    scanQRCodeEnterMD: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '0') {
            continue
          } else if (qrCodeObj.tableContent[i].InitType !== '3') {
            loadingInstance.close()
            that.$message.error('该标签号不是通过委外订单直接或者间接生成的，请扫描委外订单直接或者间接生成的标签号！')
            that.scanQRCode = ''
            return
          } else if (that.mesSourceInterID && that.mesSourceInterID !== qrCodeObj.tableContent[i].SubContractInterID) {
            loadingInstance.close()
            that.$message.error('该标签号不是通过该委外订单生成的，请扫描该委外订单生成的标签号！')
            that.scanQRCode = ''
            return
          } else {
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
                break
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '0') {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          that.scanQRCodes.push(qrCodeObj.tableContent[i])
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该外箱标签号中的没有可以收料通知的内箱标签！')
          return
        }
        if (!that.mesSourceInterID) {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            }
            that.$refs.mesSourceInterIDTableSelect.setSelected(qrCodeObj.tableContent[i].SubContractInterID, qrCodeObj.tableContent[0].SubContractBillNo)
            break
          }
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        that.$refs.mesSourceInterIDTableSelect.clearSelected()
      }
    },

    // 收料通知
    subInStockNotice: async function () {
      const that = this
      if (!that.mesSourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (!that.mesSourceInterID) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.subPOInStockInfo.CheckMethod) {
        that.$message.error('请选择检验方式！')
        return
      }
      if (!that.subPOInStockInfo.DCStockID) {
        that.$message.error('请选择收料仓库！')
        return
      }
      if (!that.subPOInStockInfo.DCSPID) {
        that.$message.error('请选择收料仓位！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.ScanSubContractInStockNotice', {
        sourceTranType: that.mesSourceTranType,
        sourceInterID: that.mesSourceInterID,
        scanQRCodes: that.scanQRCodes,
        subPOInStockInfo: that.subPOInStockInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showSubInStockNoticeDialog = false
        if (rtnObj.msg) {
          that.$message.warning('生成收料通知/请检单成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('生成收料通知/请检单成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传收料通知/请检单至金蝶
    uploadSubPOInStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadPOInStock.UploadSubPOInstock', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传至金蝶成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除收料通知单
    deletedSubPOInStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该收料通知/请检单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.DeleteScanSubContractInStockNotice', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 收料通知/请检单明细显示方法
    showSubPOInStockEntryDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const subPOInStockEntryObj = await table.getTableContent('WMS_SubPOInstockEntry'
        , 10000, 1, ' EntryID ASC', " AND BillNo='" + scope.data.row.BillNo + "'")
      if (subPOInStockEntryObj.error === '000000') {
        that.subPOInStockEntry = subPOInStockEntryObj.tableContent
        that.subPOInStock = scope.data.row
        that.showSubPOInStockEntryDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 显示收料通知/请检单明细表格特征字符串转换方法
    showPOInStockEntryTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'CheckMethod') {
        return table.specialStringDisplayTransform(val, that.checkMethods)
      }
    },

    // 退料通知单生成弹出框
    showSubOutStockNoticeDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      that.showSubOutStockNoticeDialog = true
      that.outSourceInterID = ''
    },

    // 扫码方法
    outScanQRCodeEnterMD: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '7') {
            continue
          } else if (qrCodeObj.tableContent[i].InitType !== '3') {
            loadingInstance.close()
            that.$message.error('该标签号不是通过委外订单直接或者间接生成的，请扫描委外订单直接或者间接生成的标签号！')
            that.scanQRCode = ''
            return
          } else if (that.outSourceInterID && that.outSourceInterID !== qrCodeObj.tableContent[i].SubContractInterID) {
            loadingInstance.close()
            that.$message.error('该标签号不是通过该委外订单生成的，请扫描该委外订单生成的标签号！')
            that.scanQRCode = ''
            return
          } else {
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
                break
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '7') {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          that.scanQRCodes.push(qrCodeObj.tableContent[i])
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该外箱标签号中的没有可以退料通知的内箱标签！')
          return
        }
        if (!that.outSourceInterID) {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '7') {
              continue
            }
            that.outSourceInterID = qrCodeObj.tableContent[i].SubContractInterID
            break
          }
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    outDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        that.outSourceInterID = ''
      }
    },

    // 退料通知
    subOutStockNotice: async function () {
      const that = this
      if (!that.outSourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (!that.outSourceInterID) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.ScanSubContractOutStockNotice', {
        sourceTranType: that.outSourceTranType,
        sourceInterID: that.outSourceInterID,
        scanQRCodes: that.scanQRCodes,
        subPOOutStockInfo: that.subPOOutStockInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showSubOutStockNoticeDialog = false
        if (rtnObj.msg) {
          that.$message.warning('生成退料通知单成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('生成退料通知单成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传退料通知至金蝶
    uploadSubPOOutStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadPOInStock.UploadSubPOOutstock', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传至金蝶成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除退料通知单
    deletedSubPOOutStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该退料通知单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.DeleteScanSubContractOutStockNotice', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
